import { render, staticRenderFns } from "./AddonsFileForm.vue?vue&type=template&id=be050358&scoped=true&"
import script from "./AddonsFileForm.vue?vue&type=script&lang=js&"
export * from "./AddonsFileForm.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./AddonsFileForm.vue?vue&type=style&index=1&id=be050358&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be050358",
  null
  
)

export default component.exports